import { render } from "./AuthHeroPanel.vue?vue&type=template&id=cd506bec"
import script from "./AuthHeroPanel.vue?vue&type=script&lang=js"
export * from "./AuthHeroPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__